import { useEffect, useCallback } from "react";

type Callback = () => void;

/**
 * useHandlerESC - adding/removing listener on key ESC.
 * @param {CallableFunction} cb - call function on ESC.
 * @param {Boolean} needListener - to add listener base on some rules.
 * Usage:
 * const ExampleComponent = (closeMyCardsNav, showMyCards) => {
 *  useHandlerESC(closeMyCardsNav, showMyCards);
 *  return (...);
 * };
 * export default ExampleComponent;
 */
const useHandlerESC = (cb: Callback, needListener: boolean) => {
  const handleESC = useCallback(
    (event: KeyboardEvent) => {
      const keyName = event.key;
      if (keyName === "Escape") {
        cb();
      }
    },
    [cb]
  );

  useEffect(() => {
    // Capture triggering element so that focus can be returned.
    const triggeringElement = document.activeElement;

    if (needListener) {
      document.addEventListener("keyup", handleESC, true);
    } else {
      document.removeEventListener("keyup", handleESC, true);
    }

    return () => {
      document.removeEventListener("keyup", handleESC, true);
      (triggeringElement as HTMLElement).focus();
    };
  }, [handleESC, needListener]);
};

export default useHandlerESC;
